<template>
  <img :src="qrCode">
</template>

<script setup>
import QRCodeStyling from 'qr-code-styling';

const props = defineProps({
  width: {
    default: 300,
  },
  height: {
    default: 300,
  },
  type: {
    default: "canvas",
  },
  shape: {
    default: "square",
  },
  data: {
    required: true,
  },
  image: {
    default: null,
  },
  margin: {
    default: 0,
  },
  qrOptions: {
    default: {
      typeNumber: 5,
      mode: "Byte",
      errorCorrectionLevel: "Q",
    },
  },
  imageOptions: {
    default: {
      hideBackgroundDots: true,
      imageSize: 0.4,
      margin: 0,
      crossOrigin: null,
      saveAsBlob: true,
    },
  },
  dotsOptions: {
    default: {
      color: "#000000",
      gradient: null,
      type: "dots",
      roundSize: true,
    },
  },
  cornersSquareOptions: {
    default: {
      color: null,
      gradient: null,
      type: "extra-rounded",
    },
  },
  cornersDotOptions: {
    default: {
      color: null,
      gradient: null,
      type: "square",
    },
  },
  backgroundOptions: {
    default: {
      color: "transparent",
      gradient: null,
    },
  },
});

const options = ref({});
const qrCodeStyling = new QRCodeStyling(options.value);
const qrCode = ref(null);

watch(props,
  async (value) => {
    options.value = {...options.value, ...value};
  },
  { immediate: true, deep: true }
);

watch(options,
  async (value) => {
    const prev = qrCode.value;
    qrCodeStyling.update(value);
    qrCode.value = URL.createObjectURL(await qrCodeStyling.getRawData('png'));
    if (prev) URL.revokeObjectURL(prev);
  },
  { immediate: true, deep: true }
);

onBeforeUnmount(() => {
  if (qrCode.value) URL.revokeObjectURL(qrCode.value);
});
</script>

<style scoped>
img {
  max-width: 100%;
}
</style>